import { combineReducers } from 'redux';

import transactions from './transactions/reducer';
import hotWallets from './hotWallets/reducer';
import profit from './profit/reducer';
import bnixFee from './bnixFee/reducer';
import gasFeeSettings from './gasFeeSettings/reducer';
import historyReplenishment from './historyReplenishment/reducer';

export default combineReducers({
  transactions,
  hotWallets,
  profit,
  bnixFee,
  gasFeeSettings,
  historyReplenishment,
});
